import { Component, EventEmitter, Input, Output } from '@angular/core'
import { IconLegacyComponent } from '../../deprecated'
import { CapitalizeFirstLetterPipe } from '../../pipes'
import { Illustration, IllustrationComponent } from '../illustration'

@Component({
  selector: 'ftr-error-state',
  templateUrl: './error-state.component.html',
  styleUrls: ['./error-state.component.css'],
  imports: [IconLegacyComponent, IllustrationComponent, CapitalizeFirstLetterPipe],
})
/**
 * A component to display an error with a retry link
 */
export class ErrorStateComponent {
  @Input() entityName: string = ''
  @Input() small = false
  @Input() transparent = false
  @Input() errorMessage?: string
  @Output() onRetry = new EventEmitter()

  protected readonly illustration = Illustration
}
